import { Component, inject, input } from '@angular/core';
import { ModalBodyDirective, ModalComponent } from '@legacy/common-ui-shared';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { UsageQuestionnaireComponent } from '../usage-questionnaire/usage-questionnaire.component';
import { UsageQuestionnaireRenderingDefaults } from '../usage-questionnaire/usage-questionnaire-rendering.interface';

@Component({
  selector: 'wl-usage-questionnaire-modal',
  standalone: true,
  templateUrl: './usage-questionnaire-modal.component.html',
  styleUrls: [
    './usage-questionnaire-modal.component.ed.scss',
    './usage-questionnaire-modal.component.essent.scss',
  ],
  imports: [ModalComponent, UsageQuestionnaireComponent, ModalBodyDirective],
})
export class UsageQuestionnaireModalComponent {
  readonly rendering = input(UsageQuestionnaireRenderingDefaults);
  readonly modal = inject(NgbActiveModal);

  closeWithoutSubmit() {
    this.modal.close(null);
  }

  handleSubmit(values: any) {
    this.modal.close(values);
  }
}
